import getIsAutoApprove from './getIsAutoApprove';

interface GetCellTextProps {
  approvalsCount: number;
  approvalsRequired: number;
  applicationStatus: number;
  approvedStatus: number;
  translateFunc: (key: any) => string;
  // for overriding auto message
  autoTextTranslateKey?: string;
}

const getDisplayApprovalProgress = (props: GetCellTextProps) => {
  const {
    approvalsCount,
    approvalsRequired,
    applicationStatus,
    approvedStatus,
    translateFunc,
    autoTextTranslateKey = 'auto',
  } = props;

  const isAuto = getIsAutoApprove({
    approvalsCount,
    approvalsRequired,
    applicationStatus,
    approvedStatus,
  });

  const approvalCountDisplay = approvalsCount ?? '0';

  const approvalRequiredDisplay = approvalsRequired ?? '0';

  if (isAuto) {
    return translateFunc(autoTextTranslateKey);
  }
  return `${approvalCountDisplay}/${approvalRequiredDisplay}`;
};

export default getDisplayApprovalProgress;
